import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  SCHEDULING_INTERVIEW_DETAILS,
  SCHEDULING_EVENT_ID,
  SCHEDULING_INTERVIEWERS_EVENT,
  FETCH_INTERVIEWERS_LIST,
  SUGGESTED_INTERVIEW_ID,
  CREATED_INTERVIEW,
  SCHEDULED_INTERVIEW,
} from './constants';

const getInterviewDetails = async (
  { id, actionId, contactId },
  { extra: { atsHttp } }
) => {
  let url = `ats_interviews/new?ats_job_stage_id=${id}`;

  if (actionId) {
    url += `&ats_job_stage_action_id=${actionId}`;
  }

  if (contactId) {
    url += `&contact_id=${encodeURIComponent(contactId)}`;
  }

  const interviewDetails = atsHttp.get(url);

  return interviewDetails;
};

const getEventId = async (payload, { extra: { atsHttp } }) => {
  const interviewDetails = atsHttp.post(
    '/calendar_events/trigger_fetch',
    payload
  );

  return interviewDetails;
};

const gethInterviewersEvent = async ({ eventId }, { extra: { atsHttp } }) => {
  const interviewDetails = atsHttp.get(
    `calendar_events?fetch_uuid=${eventId} `
  );

  return interviewDetails;
};

const getInterviewersList = async (
  { inputValue, actionId, startDate, cb = () => {} },
  { extra: { atsHttp } }
) => {
  const interviewersList = atsHttp.get(
    `ats_interviews/interviewers?week_start_date=${startDate}${
      actionId && `&ats_job_stage_action_id=${actionId}`
    }&q=${inputValue}`
  );
  cb(interviewersList);
  return interviewersList;
};

export const fetchInterviewDetails = createAsyncThunk(
  SCHEDULING_INTERVIEW_DETAILS,
  getInterviewDetails
);

const getSuggestedInterviewerId = async (payload, { extra: { atsHttp } }) => {
  const interviewDetails = atsHttp.post(
    'ats_interviews/trigger_suggested_interviewer',
    payload
  );

  return interviewDetails;
};

const getCreatedInterview = async ({ interviewId }, { extra: { atsHttp } }) => {
  const interviewDetails = atsHttp.get(`ats_interviews/${interviewId}`);
  return interviewDetails;
};

const getScheduledInterview = async (
  { scheduleId },
  { extra: { atsHttp } }
) => {
  const interviewDetails = atsHttp.get(`ats_schedules/${scheduleId}`);
  return interviewDetails;
};

export const fetchEventId = createAsyncThunk(SCHEDULING_EVENT_ID, getEventId);

export const fetchInterviewsEvent = createAsyncThunk(
  SCHEDULING_INTERVIEWERS_EVENT,
  gethInterviewersEvent
);

export const fetchInterviewersList = createAsyncThunk(
  FETCH_INTERVIEWERS_LIST,
  getInterviewersList
);

export const fetchSuggestedInterviewerId = createAsyncThunk(
  SUGGESTED_INTERVIEW_ID,
  getSuggestedInterviewerId
);

export const fetchCreatedInterview = createAsyncThunk(
  CREATED_INTERVIEW,
  getCreatedInterview
);

export const fetchScheduledInterview = createAsyncThunk(
  SCHEDULED_INTERVIEW,
  getScheduledInterview
);
